import React from "react";
import ReactGA from "react-ga";
import { useMediaQuery } from "react-responsive";
import { Typography, Grid, withStyles } from "@material-ui/core";
import ShowMoreText from "react-show-more-text";


import theme from "../../Theme";
import DetailLabel from "./DetailLabel";

import { Skeleton as Skelly } from '@material-ui/lab';

var url = require("url");

let NODATA = false;
const notavailable = "Not Available";

const Skeleton = (props) => {
  return <Skelly animation='wave' {...props} />
}

function AboutCo({
  classes,
  companyName,
  hq,
  employees,
  website,
  about,
  founded,
  jobsLink,
  loading
}) {
  const isMobileLayout = useMediaQuery({
    query: "(max-width: 700px)",
  });

  const handleJobsClick = () => {
    logAnalyticsEvent({
      category: "Jobs Link",
      action: "Jobs Link Clicked",
      label: `Company Page for ${companyName}`,
    });
  };

  const handleWebsiteClick = () => {
    logAnalyticsEvent({
      category: "Jobs Link",
      action: "Jobs Link Clicked",
      label: `Company Page for ${companyName}`,
    });
  };

  const logAnalyticsEvent = ({ category, action, label }) => {
    if (
      window.location.hostname !== "localhost" &&
      window.location.hostname !== "127.0.0.1"
    ) {
      ReactGA.event({
        category,
        action,
        label,
      });
    }
  };

  const getJobsLink = (source) => {
    let url = "";
    try {
      url = new URL(source);
    } catch (e) {
      return <span style={{ textTransform: "capitalize" }}>Not Available</span>;
    }

    // Prettify
    if (url.hostname.substring(0, 4) === "www.") {
      url.hostname = url.hostname.substring(4);
    }

    return (
      <a href={source} target="_blank" onClick={handleJobsClick}>
        {url.hostname.includes("jobs") || url.hostname.includes("careers")
          ? `${url.hostname}`
          : `${url.hostname}/jobs`}
      </a>
    );
  };

  const hqString = hq && !NODATA ? hq : notavailable;
  const headcount = employees && !NODATA ? employees : notavailable;
  let urlString;
  try {
    const href = website;
    urlString = website && !NODATA ? url.parse(website).hostname : notavailable;
    if (urlString.substring(0, 4) === "www.") {
      urlString = urlString.substring(4);
    }
    urlString = (
      <a href={href} target="_blank" onClick={handleWebsiteClick}>
        {urlString}
      </a>
    );
  } catch (e) {
    urlString = notavailable;
  }
  const aboutString =
    about && !NODATA
      ? about.replace(/&nbsp;/g, " ")
      : "There is no description available for this company at this time.";
  const foundedString = founded && !NODATA ? founded : notavailable;

  if (isMobileLayout) {
    return (
      <div className={classes.aboutSection} style={{ paddingLeft: 0 }}>
        <div className={classes.remoteStatusHeader}>
          {
            loading ? (
              <Skeleton variant="text">
                <Typography variant="h5" gutterBottom style={{ fontFamily: "Arvo" }}>
                  About
                </Typography>
              </Skeleton>
            ) : (
              <Typography variant="h5" gutterBottom style={{ fontFamily: "Arvo" }}>
                About
              </Typography>
            )
          }
        </div>
        <div className={classes.description}>
          {
            loading ? (
              <>
                <Skeleton variant="text" />
                <Skeleton variant="text" />
              </>              
            ) : ( 
              <ShowMoreText
                lines={3}
                more="Show more"
                less="Show less"
                anchorClass=""
                expanded={false}
                width={280}
              >
                {aboutString}
              </ShowMoreText>
            )
          }
        </div>
        <Grid
          container
          spacing={1}
          style={{ margin: theme.spacing(2, 0) }}
        >
          <DetailLabel label="Founded" text={foundedString} loading={loading} />
          <DetailLabel label="Headquarters" text={hqString} loading={loading} />
          <DetailLabel label="# Employees" text={headcount} loading={loading} />
          <DetailLabel label="Website" text={urlString} loading={loading} />
          <DetailLabel label="Jobs Link" text={getJobsLink(jobsLink)} loading={loading} />
        </Grid>
      </div>
    );
  }

  const renderDetails = (loading) => {
    return (
      <Grid container spacing={1} style={{ margin: theme.spacing(2, 0) }}>
        <DetailLabel label="Founded" text={foundedString} loading={loading} />
        <DetailLabel label="HQ" text={hqString} loading={loading} />
        <DetailLabel label="# Employees" text={headcount} loading={loading} />
        <DetailLabel label="Website" text={urlString} loading={loading} />
        <DetailLabel label="Jobs Link" text={getJobsLink(jobsLink)} loading={loading} />
      </Grid>
    )
  }

  return (
    <div className={classes.aboutSection}>
      <div className={classes.description}>
        <div className={classes.remoteStatusHeader}>
          {
            loading ? (
              <Skeleton variant="text" component="h5">
                <Typography variant="h5" gutterBottom>
                  About
                </Typography>
              </Skeleton>
            ) : (
              <Typography variant="h5" gutterBottom style={{ fontFamily: "Arvo" }}>
                About
              </Typography>
            )
          }
        </div>
        <Typography variant="body1" style={{ fontFamily: "Lato"}}>
        {
            loading ? (
              <>
                <Skeleton variant="text" />
                <Skeleton variant="text" />
              </>
            ) : (
              aboutString
            )
        }          
        </Typography>
        {renderDetails(loading)}
      </div>
    </div>
  );
}

const styles = (theme) => ({
  aboutSection: {
    textAlign: "left",
    fontFamily: "Lato",
  },
  description: {
    margin: "0 30px",
    [theme.breakpoints.down("sm")]: {
      margin: "0 8px",
    },
  },
  remoteStatusHeader: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      margin: "0 8px"
    },
  },
  "@media (max-width: 960px) and (min-width: 701px)": {
    aboutSection: {
      marginBottom: "8px",
      paddingLeft: 0,
    },
    remoteStatusHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  "@media (max-width: 700px)": {
    aboutSection: {
      marginBottom: "30px",
    },
  },
});

export default withStyles(styles)(AboutCo);
